import { ChevronDown } from 'lucide-react';
import type React from 'react';
import { Loading } from '@/components/shared';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ScrollToBottomButtonProps {
  isWorking: boolean;
  onClick: () => void;
  className?: string;
  compact?: boolean;
}

export const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  isWorking,
  onClick,
  className,
  compact = false,
}) => {
  const label = isWorking
    ? 'Case Partner is working — scroll to bottom'
    : 'Scroll to bottom';

  return (
    <Button
      aria-label={label}
      className={cn(
        'rounded-full bg-white shadow-md',
        compact ? 'h-9 w-9' : 'h-10 w-10',
        className,
      )}
      onClick={onClick}
      size="icon"
      title={label}
      type="button"
      variant="outline"
    >
      <span
        className="flex animate-scroll-control-in items-center justify-center"
        key={isWorking ? 'working' : 'idle'}
      >
        {isWorking ? (
          <Loading
            animation="bounce"
            aria-hidden="true"
            dotClassName="bg-slate-400/80"
            inline
            size="xs"
          />
        ) : (
          <ChevronDown
            aria-hidden="true"
            className={compact ? 'h-4 w-4 text-slate-500' : 'h-5 w-5 text-slate-500'}
          />
        )}
      </span>
    </Button>
  );
};
